import { createAPIra } from './index';

export default class BaseEntity {
	constructor(apira = createAPIra(), {
		errorHandler = null, /** Callback */
		forceException = false /** Прокидывание ошибки */
	} = {}) {
		this._api = apira.extend();
		this._errorHandler = errorHandler;
		this._forceException = forceException;
	}

	async request(APImethod) {
		try {
			const { response } = await APImethod();
			return response.data;
		} catch (err) {
			if (this._errorHandler != null) {
				this._errorHandler(err);

				/** Прокидывание ошибки */
				if (this._forceException) throw err;
			} else {
				throw err;
			}
		}
	}

	async requestWithHeaders(APImethod) {
		try {
			const { response } = await APImethod();
			return response;
		} catch (err) {
			if (this._errorHandler != null) {
				this._errorHandler(err);

				/** Прокидывание ошибки */
				if (this._forceException) throw err;
			} else {
				throw err;
			}
		}
	}
}
